/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {DecoratorsModule as ɵa} from './lib/decorators';